var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('form-aluno',{attrs:{"call":"index","paramId":_vm.$route.params.id},on:{"onSubmitFormAluno":_vm.onSubmitFormAluno}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }